<template>
    <div>
        <div class="form-group">
      <label>障害福祉サービス受給者証有無</label>
      <div class="flag-indicator button-style">
        <label><input type="radio" value=1 v-model="selectedDisabilityWelfare" @change="changeBeneficiaryCertificate"/><span>あり</span></label>
        <label><input type="radio" value=0 v-model="selectedDisabilityWelfare" @change="changeBeneficiaryCertificate"/><span>なし</span></label>
      </div>
    </div>
    <div class="form-group">
      <label>病歴</label>
      <span>※複数選択可</span>
      <div class="medical-history">
        <label><input type="checkbox" value="高血圧症" v-model="checkedMedicalHistory" @change="changeMedicalHistory"/><span>高血圧症</span></label>
        <label><input type="checkbox" value="脳卒中" v-model="checkedMedicalHistory" @change="changeMedicalHistory"/><span>脳卒中</span></label>
        <label><input type="checkbox" value="心臓疾患" v-model="checkedMedicalHistory" @change="changeMedicalHistory"/><span>心臓疾患</span></label>
        <label><input type="checkbox" value="糖尿病" v-model="checkedMedicalHistory" @change="changeMedicalHistory"/><span>糖尿病</span></label>
        <label><input type="checkbox" value="肝疾患" v-model="checkedMedicalHistory" @change="changeMedicalHistory"/><span>肝疾患</span></label>
        <label><input type="checkbox" value="癌" v-model="checkedMedicalHistory" @change="changeMedicalHistory"/><span>癌</span></label>
        <label><input type="checkbox" value="アレルギー疾患" v-model="checkedMedicalHistory" @change="changeMedicalHistory"/><span>アレルギー疾患</span></label>
        <label><input type="checkbox" value="精神神経系疾患" v-model="checkedMedicalHistory" @change="changeMedicalHistory"/><span>精神神経系疾患</span></label>
        <label><input type="checkbox" value="てんかん" v-model="checkedMedicalHistory" @change="changeMedicalHistory"/><span>てんかん</span></label>
      </div>
    </div>
    </div>
</template>

<script>
export default {
    name: "NursingPage3",
    data () {
        return {
            selectedDisabilityWelfare: Number,
            checkedMedicalHistory: [],
        }
    },
    methods: {
      changeBeneficiaryCertificate() {
        this.$emit("handle-change-beneficiary-certificate",this.selectedDisabilityWelfare)

      },
      changeMedicalHistory() {
        this.$emit("handle-change-medical-history",this.checkedMedicalHistory)

      }
    }
}
</script>

<style scoped>
label {
  margin-right: 5px; /* ボタン同士の間隔 */
}

label input {
  display: none; /* デフォルトのinputは非表示にする */
}

label span {
  color: gray;
  font-size: 1rem;
  border: 1px solid gainsboro; /* 淵の線を指定 */
  border-radius: 20px; /* 角丸を入れて、左右が丸いボタンにする */
  padding: 3% 5%; /* 上下左右に余白をトル */
  display: inline-block;
  min-width: 34%;
  text-align: center;
  margin: 3% 0 3% 0;
}

@media screen and (max-width:375px) and (max-height: 667px) { 
  label span {
    padding: 2% 5%; /* 上下左右に余白をトル */
  }
}
</style>


// WEBPACK FOOTER //
// src/templates/NursingPage3.vue